<iss-typeahead-select
  [formControl]="control.control"
  [items$]="items$"
  [loading$]="loading$"
  [placeholder]="placeholder || 'iss-wo-common.label.site' | translate"
  [readonly]="readonly"
  [forceTypeahead]="forceTypeahead"
  [withAll]="withAll"
  [stringify]="stringify"
  [content]="content"
  [identity]="identity"
  [matcher]="matcher"
  [multi]="multi"
  [loading]="loading"
  [clearable]="clearable"
/>
